<lib-input-base
  label="{{ '#HARDWARE_MANAGEMENT.FORM.PRODUKT.LABEL' | translate }}"
  controlName="produkt"
  [required]="required"
  (valueChange)="valueChanged($event)"
  (select)="select($event); inputBase.isOpen$.next(false)"
  (formReset)="resetForm($event)"
  (edit)="edit($event)"
  [entities]="(products$ | async) ?? []"
  [clearInputTrigger]="clearInput$ | async"
  [editing]="productInEditing$ | async"
  [readonly]="readonly"
  [formGroup]="formGroup"
  [entityCreateTemplate]="createTemplate"
  [entityEditTemplate]="editTemplate"
  [entityResultTemplate]="resultTemplate"
  [filter]="filterProducts"
  #inputBase>
</lib-input-base>

<ng-template #editTemplate let-productInEditing>
  <form [formGroup]="productForm" class="flex flex-col px-4 py-4 gap-4">
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.PRODUKT.LABEL' | translate }}" formControlName="produkt"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BEZEICHNUNG' | translate }}" formControlName="bezeichnung"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BESCHREIBUNG' | translate }}" formControlName="beschreibung"></soft-input>
    <lib-hersteller-input></lib-hersteller-input>
   <!-- <soft-entity-input formControlName="hersteller" placeholder="hersteller">
      <ng-template let-entity="entity">
        {{ entity?.id }} - {{ entity?.hersteller || entity?.bezeichnung }}
      </ng-template>
    </soft-entity-input> -->
    <div class="flex w-full items-center justify-between">
      <a class="soft-link" (click)="resetForm(productInEditing)">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.RESET' | translate }}</a>
      <button class="soft-button primary" type="submit" (click)="saveEdit(productInEditing)">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.SAVE' | translate }}</button>
    </div>
  </form>
</ng-template>

<ng-template #createTemplate>
  <form [formGroup]="productForm" class="flex flex-col px-4 py-4 gap-4">
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.PRODUKT.LABEL' | translate }}" formControlName="produkt"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BEZEICHNUNG' | translate }}" formControlName="bezeichnung"></soft-input>
    <soft-input placeholder="{{ '#HARDWARE_MANAGEMENT.FORM.COMMON.BESCHREIBUNG' | translate }}" formControlName="beschreibung"></soft-input>
    <lib-hersteller-input></lib-hersteller-input>
    <div class="flex w-full items-center justify-between">
      <a class="soft-link" (click)="resetForm()">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.RESET' | translate }}</a>
      <button class="soft-button primary" type="submit" (click)="createProduct(productForm.value)">{{ '#HARDWARE_MANAGEMENT.FORM.ACTIONS.SAVE' | translate }}</button>
    </div>
  </form>
</ng-template>

<ng-template #resultTemplate let-entity>
  <div class="grid" style="grid-template-columns: auto 2.5rem">
    <div class="!flex w-full flex-col justify-center border-r border-r-secondary border-solid py-2 pr-4 text-ellipsis overflow-hidden" (click)="select(entity); inputBase.isOpen$.next(false)">
      <strong [title]="$safeNavigationMigration(entity?.produkt)" class="text-ellipsis overflow-hidden">{{ entity.produkt }}</strong>
      <div class="text-sm opacity-75 text-ellipsis overflow-hidden">{{ entity?.bezeichnung }}</div>
      <div class="text-sm opacity-75 text-ellipsis overflow-hidden">{{ entity?.hersteller?.hersteller || entity?.hersteller?.bezeichnung }}</div>
    </div>
    <div class="h-full pr-2 w-full min-h-[3rem] hover:bg-secondary-300 flex items-center justify-center flex-grow flex-shrink-0 text-lg cursor-pointer" (click)="edit(entity)">
      <i class="ml-3 fa-regular fa-pen-to-square"></i>
    </div>
  </div>
</ng-template>
